// extracted by extract-css-chunks-webpack-plugin
module.exports = {"skipLink":"css-y-hXWFyVdA","mainContainer":"css-QxDijKVUcv"};